import React from 'react'

const BuyerAnalytics = () => {
  return (
    <div>BuyerAnalytics</div>
  )
}

export default BuyerAnalytics